import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=39fbb98c&scoped=true"
import script from "./_category.vue?vue&type=script&lang=js"
export * from "./_category.vue?vue&type=script&lang=js"
import style0 from "./_category.vue?vue&type=style&index=0&id=39fbb98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fbb98c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExploreCard: require('/workspace/components/ExploreCard.vue').default})
